module.exports = __webpack_public_path__ + "assets/sent-email-done.fb7fde0f.svg";